var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1024 1024",
    height: "1024px",
    id: "Website",
    viewBox: "0 0 1024 1024",
    width: "1024px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.9397 0.342 0.342 -0.9397 275.869 765.6678)",
    gradientUnits: "userSpaceOnUse",
    id: "bg_1_",
    x1: 464.3252,
    x2: -194.0465,
    y1: -73.2012,
    y2: 711.4601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3990"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1544,
    style: {
      stopColor: "#2B4296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4063,
    style: {
      stopColor: "#2A5AA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#2882C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27AAE1"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512.001,
    cy: 512,
    fill: "url(#bg_1_)",
    id: "bg",
    r: 512
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,214.419c-164.35,0-297.581,133.231-297.581,297.581  c0,164.35,133.231,297.581,297.581,297.581S809.581,676.35,809.581,512C809.581,347.65,676.35,214.419,512,214.419z   M736.257,386.927c10.568,18.882,18.661,39.007,24.121,59.966H660.331c-3.699-20.362-9.134-40.442-16.337-59.966H736.257z   M632.869,554.772l-28.023-85.423l17.881-7.904l19.932,66.516l15.438-42.472h19.678l15.438,42.472l19.93-66.516l17.88,7.904  L703,554.772l-17.604,7.781l-17.461-58.277l-17.462,58.277L632.869,554.772z M634.964,577.104  c-3.991,20.33-9.854,40.334-17.625,59.695h-92.88v-59.695H634.964z M693.496,330.504c9.871,9.869,18.82,20.411,26.843,31.505  h-86.636c-17.049-37.16-40.803-71.752-71.262-101.759C611.776,270.029,657.132,294.138,693.496,330.504z M524.459,259.527  c35.06,29.154,62.229,64.197,81.509,102.482h-81.509V259.527z M524.459,386.927h92.77c7.825,19.446,13.727,39.542,17.735,59.966  H524.459V386.927z M499.541,259.84v102.169h-81.133C437.618,323.861,464.663,288.932,499.541,259.84z M389.41,446.894  c4.01-20.424,9.91-40.52,17.734-59.966h92.396v59.966H389.41z M419.154,469.35l-28.022,85.423l-17.604,7.781l-17.461-58.277  l-17.462,58.277l-17.604-7.781L292.98,469.35l17.88-7.904l19.93,66.516l15.438-42.472h19.678l15.438,42.472l19.931-66.516  L419.154,469.35z M330.504,330.504c36.477-36.478,82.002-60.619,131.515-70.34c-30.501,30.027-54.281,64.649-71.347,101.845h-87.011  C311.684,350.915,320.634,340.373,330.504,330.504z M287.743,386.927h92.638c-7.204,19.523-12.639,39.604-16.337,59.966h-100.42  C269.082,425.934,277.175,405.81,287.743,386.927z M287.592,636.801c-10.493-18.804-18.535-38.835-23.968-59.694h100.42  c3.681,20.269,9.082,40.257,16.235,59.694H287.592z M330.504,693.496c-9.951-9.95-18.967-20.583-27.04-31.777h87.085  c17.072,37.297,40.895,72.018,71.469,102.116C412.506,754.115,366.98,729.974,330.504,693.496z M499.541,764.16  c-34.961-29.161-62.053-64.188-81.271-102.441h81.271V764.16z M499.541,636.801h-92.506c-7.771-19.361-13.634-39.366-17.624-59.694  h110.13V636.801z M511.855,504.276l-17.463,58.277l-17.603-7.781l-28.022-85.423l17.882-7.904l19.93,66.516l15.437-42.472h19.679  l15.438,42.472l19.929-66.516l17.882,7.904l-28.022,85.423l-17.603,7.781L511.855,504.276z M524.459,764.473V661.719h81.646  C586.818,700.11,559.604,735.25,524.459,764.473z M693.496,693.496c-36.364,36.366-81.72,60.475-131.053,70.253  c30.532-30.08,54.326-64.77,71.383-102.03h86.71C712.463,672.913,703.447,683.546,693.496,693.496z M736.408,636.801h-92.313  c7.154-19.438,12.556-39.427,16.236-59.694h100.045C754.943,597.965,746.901,617.997,736.408,636.801z",
    fill: "#FFFFFF",
    id: "Website_1_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.58d944a9ce251e5b6effd8ebf6cf7945.svg";
export { ForwardRef as ReactComponent };